export default __webpack_public_path__ + "static/volquetas-a203a4a393d3fa10aa2340679780f0f1.png";